import React, { useState } from 'react'
import SbEditable from 'storyblok-react'
import Image from '../atoms/Image'
import FadeInRightEffect from '../effect/FadeInRightEffect'

// TODO: get @root.name

const PinpointBlock = ({ block }) => {
  const [hoverPinpointState, setHoverPinpointState] = useState(null)
  return (
    <SbEditable content={block}>
      <section className={`pinpoint-block pinpoint-block-${block.orientation}`}>
        <div className="pinpoint-block-wrapper">
          <div className="pinpoint-block-container">
            <div className="pinpoint-block-row">
              <div className="pinpoint-block-head">
                <div className="pinpoint-block-head-wrapper">
                  {/* <div className="h2-kicker">@root.name</div> */}
                  <h2>{block.headline}</h2>
                  <div className="h2-subheadline">{block.subheadline}</div>
                </div>
              </div>
              <div className="pinpoint-block-image">
                <div
                  data-rellax-center={true}
                  data-rellax-speed={-1}
                  className="pinpoint-block-image-wrapper"
                >
                  <Image
                    className="img-fluid"
                    image={block.augmented_image.image}
                    alt={block.augmented_image.alt}
                    hasTransforms={true}
                  />
                  <div className="pinpoint-block-pins">
                    {block.augmented_image?.hotspots?.length > 0 &&
                      block.augmented_image?.hotspots?.map((item, index) => (
                        <div
                          style={{ left: `${item.x}%`, top: `${item.y}%` }}
                          className={`pinpoint-block-pins-item pinpoint-block-pins-item-${
                            item.variant
                          } ${
                            hoverPinpointState === `dot-${block._uid}-${index}`
                              ? 'active'
                              : ''
                          }`}
                          key={index}
                        >
                          <span>
                            {block._uid}-{index}
                          </span>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="pinpoint-block-pin-descriptions">
                {block.augmented_image?.hotspots?.length > 0 &&
                  block.augmented_image?.hotspots?.map((item, index) => (
                    <div
                      className="pinpoint-block-pin-descriptions-item"
                      key={index}
                      onMouseEnter={() =>
                        setHoverPinpointState(`dot-${block._uid}-${index}`)
                      }
                      onMouseLeave={() => setHoverPinpointState(null)}
                    >
                      <FadeInRightEffect className="pinpoint-block-pin-descriptions-item-title">
                        {item.title}
                      </FadeInRightEffect>
                      <FadeInRightEffect className="pinpoint-block-pin-descriptions-item-subtitle">
                        {item.text}
                      </FadeInRightEffect>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default PinpointBlock
